var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9588D997-ED77-45BD-8A8D-26AB879DBB28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-530.000000, -1544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-settings-line",
    transform: "translate(530.000000, 1544.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14 L12,16 C8.6862915,16 6,18.6862915 6,22 L4,22 C4,17.581722 7.581722,14 12,14 L12,14 Z M12,13 C8.685,13 6,10.315 6,7 C6,3.685 8.685,1 12,1 C15.315,1 18,3.685 18,7 C18,10.315 15.315,13 12,13 Z M12,11 C14.21,11 16,9.21 16,7 C16,4.79 14.21,3 12,3 C9.79,3 8,4.79 8,7 C8,9.21 9.79,11 12,11 Z M14.595,18.812 C14.468205,18.2784293 14.468205,17.7225707 14.595,17.189 L13.603,16.616 L14.603,14.884 L15.595,15.457 C15.9931626,15.0798803 16.4744609,14.8017207 17,14.645 L17,13.5 L19,13.5 L19,14.645 C19.532,14.803 20.012,15.085 20.405,15.457 L21.397,14.884 L22.397,16.616 L21.405,17.189 C21.5316366,17.7222514 21.5316366,18.2777486 21.405,18.811 L22.397,19.384 L21.397,21.116 L20.405,20.543 C20.0068374,20.9201197 19.5255391,21.1982793 19,21.355 L19,22.5 L17,22.5 L17,21.355 C16.4744609,21.1982793 15.9931626,20.9201197 15.595,20.543 L14.603,21.116 L13.603,19.384 L14.595,18.812 L14.595,18.812 Z M18,19.5 C18.8284271,19.5 19.5,18.8284271 19.5,18 C19.5,17.1715729 18.8284271,16.5 18,16.5 C17.1715729,16.5 16.5,17.1715729 16.5,18 C16.5,18.8284271 17.1715729,19.5 18,19.5 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStaff);
export default __webpack_public_path__ + "static/media/menu_staff.f285b79b02e15ffa15215c8a19b48247.svg";
export { ForwardRef as ReactComponent };